import React from "react";

const iconSprites = {
  phone: "css/fontawesome-free-5.15.3-web/sprites/solid.svg#phone",
  whatsapp: "css/fontawesome-free-5.15.3-web/sprites/brands.svg#whatsapp",
  instagram: "css/fontawesome-free-5.15.3-web/sprites/brands.svg#instagram",
  linkedin: "css/fontawesome-free-5.15.3-web/sprites/brands.svg#linkedin-in"
};

const Footer = ({ data }) => {
  if (!data) return null;
  return (
    <footer id="footer">
      <a className="footer-mark" href="#home" aria-label="Back to top">Billy Fong</a>
      <div className="footer-bottom">
        <div className="footer-socials">
          {data.socialLinks.map(item => (
            <a
              key={item.platformName}
              href={item.profileUrl}
              target={item.profileUrl.startsWith("http") ? "_blank" : undefined}
              rel={item.profileUrl.startsWith("http") ? "noreferrer" : undefined}
              aria-label={item.platformName === "phone" ? "Call Billy Fong" : `Visit Billy Fong on ${item.platformName}`}
            >
              <svg className="social-icon" viewBox="0 0 512 512" aria-hidden="true" focusable="false">
                <use href={iconSprites[item.platformName]} />
              </svg>
              <span className="social-label">{item.platformName}</span>
            </a>
          ))}
        </div>
        <div className="footer-meta">
          <a className="back-to-top" href="#home"><span>Back to top</span><span aria-hidden="true">↑</span></a>
          <p>{data.copyrightText}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
